<template>
  <div>
    <page-header title="Overview" breadcrumb="Billings & Payment > Overview" />
    <div class="card mt-3" style="padding:0">
      <div class="grid gap-2 grid-cols-2 w-full">
        <account-receivables-overview />
        <account-payables-overview />
        <account-collections-overview />
        <account-payments-overview />
      </div>
    </div>
  </div>
</template>

<script>
import AccountReceivablesOverview from "@/components/3pl/Billings/account-receivables-overview.vue";
import AccountPayablesOverview from "@/components/3pl/Billings/account-payables-overview.vue";
import AccountCollectionsOverview from "@/components/3pl/Billings/account-collections-overview.vue";
import AccountPaymentsOverview from "@/components/3pl/Billings/account-payments-overview.vue";

export default {
  components: {
    AccountReceivablesOverview,
    AccountPayablesOverview,
    AccountCollectionsOverview,
    AccountPaymentsOverview,
  },
  data() {
    return {};
  },
};
</script>

<style></style>
